import { render, staticRenderFns } from "./newSpecialistDetails.vue?vue&type=template&id=7b9c60c4"
import script from "./newSpecialistDetails.vue?vue&type=script&lang=js"
export * from "./newSpecialistDetails.vue?vue&type=script&lang=js"
import style0 from "./newSpecialistDetails.vue?vue&type=style&index=0&id=7b9c60c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports